"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var _1 = require(".");
var EventBridge_1 = require("../EventBridge");
var StyledPushContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 96%;\n  max-width: 752px;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  z-index: 20000;\n  transform: translate(-50%, 0);\n"], ["\n  width: 96%;\n  max-width: 752px;\n  position: fixed;\n  top: 0;\n  left: 50%;\n  z-index: 20000;\n  transform: translate(-50%, 0);\n"])));
exports.NotificationContext = react_1.createContext({
    pushNotification: function () { },
});
exports.useNotificationContext = function () { return react_1.useContext(exports.NotificationContext); };
exports.pushNotificationRemove = function (_a) {
    var notification = _a.notification, notifications = _a.notifications, setNotifications = _a.setNotifications;
    var filteredNotifications = notifications.filter(function (item) { return notification.key !== item.key; });
    setNotifications(filteredNotifications);
};
// we only want one Provider. The others should just trigger events
var isGlobalProvider = !global.NOTIFICATION_PROVIDER_EXISTS;
global.NOTIFICATION_PROVIDER_EXISTS = true;
/**
 * NotificationProvider provides a function for PushNotifications.
 * If there's more than one Provider per page, they will communicate via eventBridge,
 * so that only one is rendering the Notifications
 */
exports.NotificationProvider = function (_a) {
    var children = _a.children;
    var _b = react_1.useState([]), notifications = _b[0], setNotifications = _b[1];
    // if there is allready a global Provider, just trigger the event
    if (!isGlobalProvider) {
        return (react_1.default.createElement(exports.NotificationContext.Provider, { value: {
                pushNotification: function (notification) { return EventBridge_1.event.trigger('pushNotification', notification); },
            } }, children));
    }
    // listen to event and push them
    react_1.useEffect(function () {
        EventBridge_1.event.on('pushNotification', function (notification) {
            return setNotifications(__spreadArrays(notifications, [
                __assign(__assign({}, notification), { key: new Date().getTime().toString() }),
            ]));
        });
        return function () {
            EventBridge_1.event.off('pushNotification');
        };
    }, [notifications]);
    return (react_1.default.createElement(exports.NotificationContext.Provider, { value: {
            pushNotification: function (notification) {
                setNotifications(__spreadArrays(notifications, [
                    __assign(__assign({}, notification), { key: new Date().getTime().toString() }),
                ]));
            },
        } },
        notifications.length > 0 && (react_1.default.createElement(StyledPushContainer, null, notifications.map(function (notification) { return (react_1.default.createElement(_1.Notification, { autoClose: notification.autoClose, content: notification.content, hasClose: notification.hasClose, key: notification.key, level: notification.level, onClose: function () {
                return exports.pushNotificationRemove({
                    notification: notification,
                    notifications: notifications,
                    setNotifications: setNotifications,
                });
            } })); }))),
        children));
};
exports.default = exports.NotificationProvider;
var templateObject_1;
//# sourceMappingURL=NotificationProvider.js.map